import { useAbility } from "./useAbility.jsx";

export function useClaimBookingPermissions() {
  const { can } = useAbility();
  const domain = "ClaimBooking";

  return {
    // canView: (claim) => can(domain, "view", { claim }),
    canViewAny: () => can(domain, "viewAny"),
  };
}
